import MainModel from "../../../components/Models/main-model";
import { brandPalette } from "../../../constants/brandPalette";
import {
  Box,
  FormLabel,
  Heading,
  Textarea,
  Button,
  VStack,
  HStack,
  Text,
} from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { closeAdminHomeworkCommentModel } from "../../../modules/admin-modules/models/Actions";
import { useState, useEffect } from "react";
import { commentStuentHomeworkRequest } from "../../../modules/admin-modules/reports/Actions";
import { getAssistantsRequest } from "../../../modules/admin-modules/teachersAssistant/Actions";
import Select from "react-select";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
  adminSelectStyles,
} from "../../../components/Models/admin-modal-theme";

const modalSelectStyles = {
  ...adminSelectStyles(),
  menuPortal: (base) => ({ ...base, zIndex: 1600 }),
};

const textareaProps = {
  bg: "var(--surface-muted)",
  color: "var(--text-primary)",
  borderColor: "var(--border-subtle)",
  borderRadius: "14px",
  _placeholder: { color: "var(--text-muted)", opacity: 1 },
  _focus: {
    borderColor: brandPalette.primary,
    boxShadow: "0 0 0 3px rgba(91, 13, 22, 0.12)",
  },
};

const HomeworkComment = ({ data, homeworkId }) => {
  const openHomeworkComment = useSelector((state) => state.model.isOpen27);
  const [comment, setComment] = useState("");
  const dispatch = useDispatch();
  const assistants = useSelector((state) => state.teacherassistants.assistants);
  const [assistant, setAssistant] = useState("");
  const [assistantComment, setAssistantComment] = useState("");
  const assistantsOptions = assistants?.data?.map((data) => {
    return { value: data.id, label: data.name, sign: data.school };
  });

  useEffect(() => {
    dispatch(getAssistantsRequest());
  }, []);

  const header = (
    <Box>
      <Heading textAlign="left" color="var(--text-primary)" fontSize="20px" fontWeight="900">
        Review submission
      </Heading>
      <Text mt={1} fontSize="sm" fontWeight="700" color="var(--text-muted)">
        Add evaluation and assistant notes.
      </Text>
    </Box>
  );
  const handelAddComment = () => {
    dispatch(
      commentStuentHomeworkRequest({
        id: data?.id,
        body: {
          homework_id: homeworkId,
          student_id: data?.student?.id,
          evaluation: comment,
          assistant_id: assistant,
          assistant_comment: assistantComment,
        },
      })
    );
    dispatch(closeAdminHomeworkCommentModel());
  };
  const closeFunc = () => {
    dispatch(closeAdminHomeworkCommentModel());
    setComment("");
    setAssistant("");
    setAssistantComment("");
  };

  return (
    <MainModel
      isLoading={false}
      header={header}
      closeFunc={closeFunc}
      openVar={openHomeworkComment}
      buttonTitle={"Save changes"}
      buttonFunc={handelAddComment}
      cancelTitle="Cancel"
      contentProps={adminModalContentProps}
      headerProps={adminModalHeaderProps}
      bodyProps={adminModalBodyProps}
      footerProps={{
        borderTop: "1px solid",
        borderColor: "var(--border-subtle)",
        py: 6,
      }}
    >
      <VStack align="stretch" spacing={5} dir="ltr">
        <HStack justify="space-between" flexWrap="wrap" spacing={3}>
          <Text fontSize="sm" fontWeight="800" color="var(--text-primary)">
            Student: <Text as="span" fontWeight="900">{data?.student?.name || "N/A"}</Text>
          </Text>
          <Button
            as="a"
            href={`https://api.edutopiaonline.com/public/homework/${data?.file}`}
            target="_blank"
            size="sm"
            borderRadius="12px"
            bg="var(--surface-muted)"
            border="1px solid"
            borderColor="var(--border-subtle)"
            color="var(--text-primary)"
            fontWeight="800"
            _hover={{ bg: "var(--surface-raised)", borderColor: brandPalette.primary }}
          >
            Open file
          </Button>
        </HStack>

        <Box w="100%">
          <FormLabel fontWeight="800" color="var(--text-primary)">
            Evaluation
          </FormLabel>
          <Textarea
            id="comment"
            {...textareaProps}
            placeholder="Write the evaluation…"
            onChange={(e) => setComment(e.target.value)}
            name="homework"
          />
        </Box>

        <Box w="100%">
          <FormLabel fontWeight="800" color="var(--text-primary)">
            Assistant
          </FormLabel>
          <Select
            styles={modalSelectStyles}
            options={assistantsOptions}
            menuPortalTarget={typeof document !== "undefined" ? document.body : null}
            menuPosition="fixed"
            onChange={(e) => {
              setAssistant(e.value);
              document.getElementById("comment").value += "\n\n" + e.sign;
              setComment(document.getElementById("comment").value);
            }}
            placeholder="Select assistant"
          />
        </Box>

        <Box w="100%">
          <FormLabel fontWeight="800" color="var(--text-primary)">
            Assistant notes
          </FormLabel>
          <Textarea
            id="assistantComment"
            {...textareaProps}
            placeholder="Write assistant notes…"
            onChange={(e) => setAssistantComment(e.target.value)}
            name="homework"
          />
        </Box>
      </VStack>
    </MainModel>
  );
};

export default HomeworkComment;
